module.exports = __webpack_public_path__ + "img/icon_tea.8d8f2983.png";